(() => {
  const initRail = (rail) => {
    if (!rail || rail.dataset.cjByScrollsnapReady === 'true') return;
    rail.dataset.cjByScrollsnapReady = 'true';
    const parent = rail.parentElement;
    const prev = parent?.querySelector('.slider-button--prev');
    const next = parent?.querySelector('.slider-button--next');
    const indicators = parent?.querySelectorAll('.indicator') || [];
    const slides = () => Array.from(rail.children);
    const indexNow = () => {
      const list = slides();
      if (!list.length) return 0;
      const left = rail.scrollLeft;
      let best = 0, dist = Infinity;
      list.forEach((el, i) => { const d = Math.abs(el.offsetLeft - left); if (d < dist) { dist = d; best = i; } });
      return best;
    };
    const go = (index) => {
      const list = slides();
      if (!list.length) return;
      const loop = rail.dataset.loop === 'true';
      if (loop) index = (index + list.length) % list.length;
      else index = Math.max(0, Math.min(index, list.length - 1));
      rail.scrollTo({left: list[index].offsetLeft, behavior: 'smooth'});
    };
    prev?.addEventListener('click', () => go(indexNow() - 1));
    next?.addEventListener('click', () => go(indexNow() + 1));
    indicators.forEach((indicator, i) => indicator.addEventListener('click', () => go(i)));
    if (rail.dataset.autoplay === 'true') {
      const interval = Math.max(1500, Number(rail.dataset.autoplayInterval || 3000));
      let timer = setInterval(() => go(indexNow() + 1), interval);
      const pause = () => { clearInterval(timer); timer = null; };
      const resume = () => { if (!timer) timer = setInterval(() => go(indexNow() + 1), interval); };
      rail.addEventListener('pointerdown', pause, {passive:true});
      rail.addEventListener('pointerup', resume, {passive:true});
      rail.addEventListener('mouseenter', pause);
      rail.addEventListener('mouseleave', resume);
    }
  };
  const init = () => document.querySelectorAll('.cj-beyours-page ul[is="scroll-snap-slider"]').forEach(initRail);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
